import { createBrowserRouter, Outlet } from 'react-router';
import Content from './layouts/content';
import Dashboard from './features/dashboard';
import Template from './features/template';
import Machine from './features/machine';
import MachineList from './features/machine/list';
import MachineHeatmap from './features/machine/heatmap';
import Chain from './features/chain';
import MachineDetails from './features/machine/details/info';
import TemplateList from './features/template/list';
import Insight from './features/insight';
import Knowledge from './features/knowledge';
import KnowledgeLanding from './features/knowledge/landing';
import MachineForm from './features/machine/form';
import NotFound from './components/notFound';
import TemplateForm from './features/template/form';
import Diagnose from './features/diagnose';
import DiagnoseLanding from './features/diagnose/landing';
import DiagnoseMachine from './features/diagnose/machine';
import MachineDetailsContainer from './features/machine/details';
import MachineSolutionGrid from './features/machine/details/solutionGrid';
import Flow from './features/flow';
import DiagnoseInsight from './features/insight/diagnose';
import PeopleInsight from './features/insight/people';
import SkillsetInsight from './features/insight/skillset';
import Login from './features/login';
import ResetPassword from './features/login/resetPassword';
import ChangePassword from './features/login/changePassword';
import TemplateDetailsContainer from './features/template/details';
import TemplateDetails from './features/template/details/info';
import TemplateSolutionGrid from './features/template/details/solutionGrid';
import TemplateIssues from './features/template/details/issues';
import TemplateCauses from './features/template/details/causes';
import User from './features/user';
import UserList from './features/user/list';
import MachineIssues from './features/machine/details/issue';
import MachineCauses from './features/machine/details/cause';
import MachineRoutines from './features/machine/details/routine';
import TemplateRoutines from './features/template/details/routines';
import Client from './features/client';
import ClientList from './features/client/list';
import LicenseForClient from './features/client/license';
import MachineResourceLibrary from './features/machine/details/resourceLibrary';
import TemplateResourceLibrary from './features/template/details/resourceLibrary';

const machine = {
  path: 'machine',
  element: <Machine />,
  children: [
    {
      path: '',
      element: <MachineList />,
    },
    {
      path: ':id/edit',
      element: <MachineForm />,
    },
    {
      path: ':id',
      element: <MachineDetailsContainer />,
      children: [
        {
          path: '',
          element: <MachineDetails />,
        },
        {
          path: 'solutionGrid',
          element: <MachineSolutionGrid />,
        },
        {
          path: 'issue',
          element: <MachineIssues />,
        },
        {
          path: 'cause',
          element: <MachineCauses />,
        },
        {
          path: 'routine',
          element: <MachineRoutines />,
        },
        {
          path: 'resourceLibrary',
          element: <MachineResourceLibrary />,
        },
        {
          path: '*',
          element: <NotFound />,
        },
      ],
    },
    {
      path: 'add',
      element: <MachineForm />,
    },
    {
      path: 'heatmap',
      element: <MachineHeatmap />,
    },
    {
      path: '*',
      element: <NotFound />,
    },
  ],
};

const template = {
  path: 'template',
  element: <Template />,
  children: [
    {
      path: '',
      element: <TemplateList />,
    },
    {
      path: ':id/edit',
      element: <TemplateForm />,
    },
    {
      path: ':id',
      element: <TemplateDetailsContainer />,
      children: [
        {
          path: '',
          element: <TemplateDetails />,
        },
        {
          path: 'solutionGrid',
          element: <TemplateSolutionGrid />,
        },
        {
          path: 'issue',
          element: <TemplateIssues />,
        },
        {
          path: 'cause',
          element: <TemplateCauses />,
        },
        {
          path: 'routine',
          element: <TemplateRoutines />,
        },
        {
          path: 'resourceLibrary',
          element: <TemplateResourceLibrary />,
        },
        {
          path: '*',
          element: <NotFound />,
        },
      ],
    },
    {
      path: 'add',
      element: <TemplateForm />,
    },
    machine,
    {
      path: '*',
      element: <NotFound />,
    },
  ],
};

const diagnose = {
  path: 'diagnose',
  element: <Diagnose />,
  children: [
    {
      path: '',
      element: <DiagnoseLanding />,
    },
    {
      path: 'machine',
      element: <Outlet />,
      children: [
        {
          path: ':id',
          element: <DiagnoseMachine />,
        },
      ],
    },
    {
      path: '*',
      element: <NotFound />,
    },
  ],
};

const router = createBrowserRouter([
  {
    path: '',
    element: <Content />,
    children: [
      {
        path: '',
        element: <Dashboard />,
      },
      {
        path: 'change-password',
        element: <ChangePassword />,
      },
      {
        path: 'knowledge',
        element: <Knowledge />,
        children: [
          {
            path: '',
            element: <KnowledgeLanding />,
          },
          {
            path: 'flow',
            element: <Flow />,
          },
          machine,
          template,
          {
            path: '*',
            element: <NotFound />,
          },
        ],
      },
      diagnose,
      {
        path: 'chain',
        element: <Chain />,
        children: [
          {
            path: '',
            element: <Chain />,
          },
        ],
      },
      {
        path: 'insight',
        element: <Insight />,
        children: [
          {
            path: '',
            // element: <NotFound />,
            element: <DiagnoseInsight />,
          },
          {
            path: 'diagnose',
            // element: <NotFound />,
            element: <DiagnoseInsight />,
          },
          {
            path: 'people',
            // element: <NotFound />,
            element: <PeopleInsight />,
          },
          {
            path: 'skillset',
            // element: <NotFound />,
            element: <SkillsetInsight />,
          },
          {
            path: '*',
            element: <NotFound />,
          },
        ],
      },
      {
        path: 'user',
        element: <User />,
        children: [
          {
            path: '',
            element: <UserList />,
          },
          {
            path: '*',
            element: <NotFound />,
          },
        ],
      },
      {
        path: 'client',
        element: <Client />,
        children: [
          {
            path: '',
            element: <ClientList />,
          },
          {
            path: ':id/license',
            element: <LicenseForClient />,
          },
          {
            path: '*',
            element: <NotFound />,
          },
        ],
      },
      {
        path: '*',
        element: <NotFound />,
      },
    ],
  },
  {
    path: '/login',
    element: <Login />,
  },
  {
    path: '/reset-password',
    element: <ResetPassword />,
  },
  {
    path: '*',
    element: <NotFound showIcon />,
  },
]);

export default router;
